import React from "react";
import PropTypes from "prop-types";
import { Typography, makeStyles } from "@material-ui/core";
import Select from "./Select";

const styles = makeStyles((theme) => ({
  wrapper: {
    marginTop: 14,
    marginBottom: 14,
  },
  label: {
    fontSize: 14,
    fontWeight: 600
  },
}));

function LabeledSelect(props) {
  let classes = styles(),
    { label, ...rest } = props;

  return (
    <div className={classes.wrapper}>
      <Typography className={classes.label}>{label}</Typography>
      <Select margin="dense" {...rest} />
    </div>
  );
}

LabeledSelect.propTypes = {
  label: PropTypes.string,
};

export default LabeledSelect;
